var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50789 10.2922H6.17456",
    stroke: "#6C738A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84106 8.66528V11.9986",
    stroke: "#6C738A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43997 1.67868L8.41997 1.72534L6.48664 6.21201H4.58664C4.13331 6.21201 3.69997 6.30534 3.30664 6.47201L4.47331 3.68534L4.49997 3.61868L4.54664 3.51201C4.55997 3.47201 4.57331 3.43201 4.59331 3.39868C5.46664 1.37868 6.45331 0.918676 8.43997 1.67868Z",
    stroke: "#6C738A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0332 6.34538C11.7332 6.25204 11.4132 6.21204 11.0932 6.21204H6.48657L8.41991 1.72538L8.43991 1.67871C8.53991 1.71204 8.63324 1.75871 8.73324 1.79871L10.2066 2.41871C11.0266 2.75871 11.5999 3.11204 11.9466 3.53871C12.0132 3.61871 12.0666 3.69204 12.1132 3.77871C12.1732 3.87204 12.2199 3.96538 12.2466 4.06538C12.2732 4.12538 12.2932 4.18538 12.3066 4.23871C12.4866 4.79871 12.3799 5.48538 12.0332 6.34538Z",
    stroke: "#6C738A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3477 9.46549V10.7655C14.3477 10.8988 14.3411 11.0322 14.3344 11.1655C14.2077 13.4922 12.9077 14.6655 10.4411 14.6655H5.24106C5.08106 14.6655 4.92106 14.6522 4.76773 14.6322C2.64773 14.4922 1.5144 13.3588 1.3744 11.2388C1.3544 11.0855 1.34106 10.9255 1.34106 10.7655V9.46549C1.34106 8.12549 2.1544 6.97216 3.3144 6.47216C3.7144 6.30549 4.14106 6.21216 4.5944 6.21216H11.1011C11.4277 6.21216 11.7477 6.25883 12.0411 6.34549C13.3677 6.75216 14.3477 7.99216 14.3477 9.46549Z",
    stroke: "#6C738A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47325 3.6853L3.30659 6.47197C2.14659 6.97197 1.33325 8.1253 1.33325 9.4653V7.51197C1.33325 5.61864 2.67992 4.03864 4.47325 3.6853Z",
    stroke: "#6C738A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3457 7.51185V9.46519C14.3457 7.99852 13.3724 6.75185 12.0391 6.35185C12.3857 5.48519 12.4857 4.80519 12.3191 4.23852C12.3057 4.17852 12.2857 4.11852 12.2591 4.06519C13.4991 4.70519 14.3457 6.01852 14.3457 7.51185Z",
    stroke: "#6C738A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAdd);
export default __webpack_public_path__ + "90252cc1e52a8d8a9f9904638767e9b8.svg";
export { ForwardRef as ReactComponent };